import React, { useEffect, useState, useRef } from "react";
import classes from "./Payroll.module.css";
import Footer from "../../Accoungting/Footer/Footer";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../../Assets/searchicon.png";
import filter from "../../../Assets/filter.png";
import { Pen, Trash2, Printer, Eye } from "lucide-react";
import axios from "axios";
import { BASE_URL } from '../../../Components/Styles/API/API';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Button, Modal, Form, Spinner, Tab, Tabs, Row, Col, Popover, Table,OverlayTrigger, Tooltip } from 'react-bootstrap';
import Select from "react-select";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";
import Swal from "sweetalert2";
import CurrencyInput from "react-currency-input-field";
import PaymentsUploadModal from "../../Accoungting/HeaderNav/Journal/PaymentsUploadModal";
import upload from "../../../Assets/upload.svg"
import HeaderNav from "../../Budget/Budget Dashboard/HeaderNav/HeaderNav";
import { BsCalendar } from 'react-icons/bs';
import { FaCalendarCheck } from "react-icons/fa";
import { FaCalendarXmark } from "react-icons/fa6";




const Payroll = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show1, setShow1] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
  const [show2, setShow2] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const handleShow1 = () => setShow1(true);
  const handleShow2 = () => setShow2(true);
  const handleShowEdit = () => setShowEdit(true);
  const handleClose1 = () => setShow1(false);
  const handleClose2 = () => setShow2(false);
  const handleCloseEdit = () => setShowEdit(false);
  const [selectedRadio, setSelectedRadio] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [description, setDescription] = useState("");
  const [refno, setRefNo] = useState("");
  const [amount, setAmount] = useState("");
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [bankOptions2, setBankOptions2] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  // const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedBank2, setSelectedBank2] = useState(null);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [addpaymenntLoad, setAddPaymenntLoad] = useState(false);
  const [addpaymenntLoad2, setAddPaymenntLoad2] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [totalEntries, setTotalEntries] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [bearer, setBearer] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [currLoading, setCurrLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [user, setUser] = useState('');
  const [loanBen,  setLoanBen] = useState([]);
 const [selectedProvinceFilter, setSelectedProvinceFilter] = useState(null);
  const [selectedContinentFilter, setSelectedContinentFilter] = useState(null);
  const [selectedRegionFilter, setSelectedRegionFilter] = useState(null);
  const [paymentType, setPaymentType] = useState('');
  const [paymentTo, setPaymentTo] = useState(null);
  const [date, setDate] = useState('');
  const [currency1, setCurrency1] = useState(null);
  const [description1, setDescription1] = useState('');
  const [modeOfPayment, setModeOfPayment] = useState('');
  const [debitAccount, setDebitAccount] = useState(null);
  const [totalAmount, setTotalAmount] = useState('');
  const [loanAccount, setLoanAccount] = useState(null);
  const [reference, setReference] = useState('');
  const [payOptions, setPayOptions] = useState([]);
  const [mopOptions, setmopOptions] = useState([]);
  const [showPay, setShowPay] = useState(false);
  const handleClosePay = () => setShowPay(false);
  // const handleShowPay = () => setShowPay(false);
  const handleShowPay = () => setShowPay(true);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [error, setError] = useState(null);
  const [continents, setContinents] = useState([]);
  const [regions, setRegions] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [rows, setRows] = useState([
    { accountId: "", accountDisplay: "", accountCode: "", amount: "", showDropdown: false },
  ]);
  const [transactionDate, setTransactionDate] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
    const [selectedEndDate, setSelectedEndDate] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  // const [description, setDescription] = useState("");
  // const [debitAccount, setDebitAccount] = useState("");
  const [outstandingAmount, setOutstandingAmount] = useState("");
  const [selectedLoanAccount, setSelectedLoanAccount] = useState("");
  // const [customerOptions, setCustomerOptions] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [loanOptions, setLoanOptions] = useState([]); // new state for loan options
  const [employeeOptions, setEmployeeOptions] = useState([]); // new state for employee options
  const [supplierOptions, setSupplierOptions] = useState([]); // new state for supplier options
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [paymentTypesLoading, setPaymentTypesLoading] = useState(false);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [supplierLoading, setSupplierLoading] = useState(false);
  const [paymentToLoading, setPaymentToLoading] = useState(false); // <-- ADD THIS LINE
  const paymentTypeLower = (selectedPaymentType || "").toLowerCase();
  // const [totalAmount, setTotalAmount] = useState("");
  const [receiptTypes, setReceiptTypes] = useState([]);
  const [receiptTypesLoading, setReceiptTypesLoading] = useState(false);
  const [tableData4, setTableData4] = useState([]);
  const [expenseOptions, setExpenseOptions] = useState([]);
  // const [currencyOptions, setCurrencyOptions] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);
  const [receiptType, setReceiptType] = useState("");
  // const [selectedCurrency, setSelectedCurrency] = useState("");
  // const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [debitAccountsLoading, setDebitAccountsLoading] = useState(false);
  const [payLoad, setPayLoad] = useState(false);
const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");
 const [loads, setLoads] = useState(false);
    const [selectOptions, setSelectOptions] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState('');
  const [suppliers, setSuppliers] = useState([]);
  const [debit1, setDebit1] = useState([]);
  const [debit2, setDebit2] = useState([]);
  const payment = location.state?.payment;
    const [openJournalModal, setOpenJournalModal] = useState(false);
    const [load, setLoad] = useState(false);
 const [tableData3, setTableData3] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState('');
 const [selectedContinent, setSelectedContinent] = useState('');
    const [selectedProvince, setSelectedProvince] = useState('');
    const [tableDataQueried, setTableDataQueried] = useState([])
    const [selectedStatus, setSelectedStatus] = useState("tableData");
    const [show, setShow] = useState(false);
      const [selectedRow, setSelectedRow] = useState('');
const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

    const readData = async () => {
      try {
        const value = await localStorage.getItem('userToken');
        const value1 = await localStorage.getItem('tobi');
  
  
        if (value !== null && value.trim() !== '') {
          setBearer(value);
        } else {
          navigate('/login');
          return;
        }
  
        if (value1 !== null) {
          setUser(value1);
        }
  
      } catch (e) {
        alert('Failed to fetch the input from storage');
      }
    };
  
    useEffect(() => {
      readData();
    }, []);


      const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  const printRef = useRef();
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };


    const handleRadioChange = (e) => {
    const value = e.target.value;
    setSelectedRadio(value);

    if (value === "general") {
      setSelectedCustomer(null);
    }
  };


  // useEffect(() => {
  //   const fetchInvoices = async () => {
  //     try {
  //       const token = localStorage.getItem("authToken");
  //       const res = await axios.get(`${BASE_URL}/v1/payments-made`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             Accept: "application/json",
  //           },
  //         }
  //       );
  //       if (res.data && res.data.status && Array.isArray(res.data.data)) {
  //         setInvoices(res.data.data);
  //       }
  //     } catch (err) {
  //       // Optionally handle error
  //       setInvoices([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchInvoices();
  // }, []);

  
  const handleContinentChange = (selectedOption) => {
    setSelectedContinent(selectedOption.value);
    setSelectedRegion('');
    setSelectedProvince('');
    // setTableData([]);
  };


  const handleRegionChange = (selectedOption) => {
    setSelectedRegion(selectedOption.value)
  }

  const handleProvinceChange = (selectedOption) => {
    setSelectedProvince(selectedOption.value)
  }
 const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  
  const handleDateChange1 = (event) => {
    setSelectedEndDate(event.target.value);
  };

      const fetchRegions = async (continentId) => {
        if (!continentId) {
          setRegions([]);
          return;
        }
    
        try {
          const response = await axios.get(`${BASE_URL}/regions?continent_id=${continentId}`, { headers });
          console.log("Regions API Response:", response.data);
    
          let regionsData = [];
          if (response.data.status && response.data.data) {
            if (Array.isArray(response.data.data)) {
              regionsData = response.data.data;
            } else if (response.data.data.regions && Array.isArray(response.data.data.regions)) {
              regionsData = response.data.data.regions;
            }
          } else if (Array.isArray(response.data)) {
            regionsData = response.data;
          } else if (response.data.data && Array.isArray(response.data.data)) {
            regionsData = response.data.data;
          }
    
          if (!Array.isArray(regionsData)) {
            console.error("Regions data is not an array:", regionsData);
            regionsData = [];
          }
    
          setRegions(regionsData);
        } catch (error) {
          console.error("Error fetching regions:", error);
          setRegions([]);
        }
      };
    
        const fetchProvincesForFilter = async (regionId) => {
          if (!regionId) {
            setProvinces([]);
            return;
          }
      
          try {
            const response = await axios.get(`${BASE_URL}/provinces?region_id=${regionId}`, { headers });
            console.log("Provinces API Response:", response.data);
      
            let provincesData = [];
            if (response.data.status) {
              if (response.data.data && response.data.data.provinces) {
                provincesData = response.data.data.provinces;
              } else if (Array.isArray(response.data.data)) {
                provincesData = response.data.data;
              } else {
                provincesData = response.data.data || [];
              }
            } else if (Array.isArray(response.data)) {
              provincesData = response.data;
            } else if (response.data.data) {
              provincesData = response.data.data || [];
            } else {
              provincesData = [];
            }
      
            if (!Array.isArray(provincesData)) {
              console.error("Provinces data is not an array:", provincesData);
              provincesData = [];
            }
      
            setProvinces(provincesData);
          } catch (error) {
            console.error("Error fetching provinces:", error);
            setProvinces([]);
          }
        };

    const fetchInvoices = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${BASE_URL}/payments-made`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          setInvoices(res.data.data);
        }
      } catch (err) {
        setInvoices([]);
      } finally {
        setLoading(false);
      }
    };

    // load invoices on mount
    useEffect(() => {
      fetchInvoices();
    }, []);

      // Fetch regions when continent filter changes
      useEffect(() => {
        if (selectedContinentFilter) {
          fetchRegions(selectedContinentFilter.value);
        } else {
          setRegions([]);
          setSelectedRegionFilter(null);
          setSelectedProvinceFilter(null);
        }
      }, [selectedContinentFilter]);
    
      // Fetch provinces when region filter changes
      useEffect(() => {
        if (selectedRegionFilter) {
          fetchProvincesForFilter(selectedRegionFilter.value);
        } else {
          setProvinces([]);
          setSelectedProvinceFilter(null);
        }
      }, [selectedRegionFilter]);
    const fetchExpenses = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch_all_payments?page=${currentPage}`, { headers });

      const results = response.data?.data?.data;
      const resultx = response.data?.data?.total;
      setTotalEntries(resultx);
      setTableData(results);
      console.log(results, "accounts full");
      const total = response.data?.data?.last_page || 1;
     
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData([]);
    } finally {
      setIsLoading(false);
    }
  };



    useEffect(() => {
      const fetchPaymentMode = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/income/get-payment-method`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.name,
            }))
            : [];
          setPaymentMode(options);
        } catch (err) {
          setPaymentMode([]);
        }
      };
      fetchPaymentMode();
    }, []);


      useEffect(() => {
        const fetchCustomers = async () => {
          try {
            const token = localStorage.getItem("authToken");
            const res = await axios.get(`${BASE_URL}/beneficiary`, {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });
            // Assuming response data is an array of currencies or customers
            const options = Array.isArray(res.data.data)
              ? res.data.data.map((item) => ({
                value: item.id,
                label: item.name,
              }))
              : [];
            setCustomerOptions(options);
          } catch (err) {
            setCustomerOptions([]);
          }
        };
        fetchCustomers();
      }, []);

      useEffect(() => {
        const fetchInvoiceOptions = async () => {
          try {
            const token = localStorage.getItem("authToken");
            const res = await axios.get(`${BASE_URL}/fetch-pending-purchases-invoice`, {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });
            console.log(res);
            // Assuming response data is an array of currencies or customers
            const options = Array.isArray(res.data.data)
              ? res.data.data.map((item) => ({
                value: item.id,
                label: `${item.invoice_number} - ${item.supplier?.name}`,
                balance: item.balance,
              }))
              : [];
            setInvoiceOptions(options);
          } catch (err) {
            setInvoiceOptions([]);
          }
        };
        fetchInvoiceOptions();
      }, []);
  

  // Skeleton loader rows
  // const SkeletonRows = () => (
  //   <>
  //     {[...Array(5)].map((_, idx) => (
  //       <tr key={idx}>
  //         {Array(10).fill().map((_, i) => (
  //           <td key={i}>
  //             <div className={classes.skeletonLoader}></div>
  //           </td>
  //         ))}
  //       </tr>
  //     ))}
  //   </>
  // );

  // Helper for status
  const statusClass = (status) => {
    if (status === "Success") return classes.greenStatus;
    if (status === "Pending") return classes.yellowStatus;
    return classes.redStatus;
  };

    // useEffect(() => {
    //   const link = document.createElement("link");
    //   link.rel = "stylesheet";
    //   link.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css";
    //   document.head.appendChild(link);
    //   return () => {
    //     document.head.removeChild(link);
    //   };
    // }, []);

  const addPayment = async () => {
    setAddPaymenntLoad(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${BASE_URL}/pay-purchase-invoice`, 

        {
          payment_type: selectedRadio,
          transaction_date: paymentDate,
          supplier_id: selectedCustomer?.value,
          supplier: customerName,
          description: description,
          payment_mode: selectedPaymentMode?.value,
          currency: selectedCurrency?.value,
          amount: amount,
          credit: selectedBank?.value,
          debit: selectedBank2?.value,
        },
        { headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });

          Swal.fire({
            imageUrl: verified,
            title: 'Success!',
            text: response.data.message,
            confirmButtonText: "Okay",
            imageWidth: 48, 
            imageHeight: 48, 
            customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
            },
            allowOutsideClick: false,
            preConfirm: () => {
              Swal.close();
            }
          });

          fetchInvoices();
          handleClose1();
          setDescription("");
          setAmount("");
          setCustomerName("");
          setPaymentDate("");
          setSelectedRadio("");
          setSelectedBank(null);
          setSelectedBank2(null);
          setSelectedCurrency(null);
          setSelectedCustomer(null);
          setSelectedPaymentMode(null);
      
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          imageUrl: crop,
          imageWidth: 48,
          imageHeight: 48,
          title: "Failed!",
          confirmButtonText: "Okay",
          text: JSON.stringify(error.response.data.message),
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myDeclineButton,
          },
          allowOutsideClick: false, // Prevent closing by clicking outside
          preConfirm: () => {
            Swal.close(); // Explicitly close the modal
          },
        });
      }
    } finally {
      setAddPaymenntLoad(false);
    }
  };

  const addPayment2 = async () => {
    setAddPaymenntLoad2(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${BASE_URL}/pay-supplier-purchase-invoice`, 

        {
          // payment_type: selectedRadio,
          transaction_date: paymentDate,
          id: selectedInvoice?.value,
          description: description,
          payment_mode: selectedPaymentMode?.value,
          currency: selectedCurrency?.value,
          amount: amount,
          credit: selectedBank?.value,
          debit: selectedBank2?.value,
        },
        { headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });

          Swal.fire({
            imageUrl: verified,
            title: 'Success!',
            text: response.data.message,
            confirmButtonText: "Okay",
            imageWidth: 48, 
            imageHeight: 48, 
            customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
            },
            allowOutsideClick: false,
            preConfirm: () => {
              Swal.close();
            }
          });

          fetchInvoices();
          handleClose2();
          setDescription("");
          setAmount("");
          setCustomerName("");
          setPaymentDate("");
          setSelectedRadio("");
          setSelectedBank(null);
          setSelectedBank2(null);
          setSelectedCurrency(null);
          setSelectedCustomer(null);
          setSelectedPaymentMode(null);
      
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          imageUrl: crop,
          imageWidth: 48,
          imageHeight: 48,
          title: "Failed!",
          confirmButtonText: "Okay",
          text: JSON.stringify(error.response.data.message),
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myDeclineButton,
          },
          allowOutsideClick: false, // Prevent closing by clicking outside
          preConfirm: () => {
            Swal.close(); // Explicitly close the modal
          },
        });
      }
    } finally {
      setAddPaymenntLoad2(false);
    }
  };


const fetchSubContinents = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents/getcontinentregions?continent_id=${selectedContinent}`, { headers });

      // console.log(response);
      const subCont = response.data?.data;
      const options1 = subCont.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData3(options1);
      console.log(response);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };

  const fetchSubRegion = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/regions/getprovincesregion?region_id=${selectedRegion}`, { headers });

      // console.log(response);
      const subCont1 = response.data?.data;
      const options2 = subCont1.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      setTableData4(options2);
      console.log(response);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };
  const fetchProvince = async () => {
    setLoad(true);
    try {
      const response = await axios.get(`${BASE_URL}/provinces`, { headers });

      // console.log(response);
      const subCont15 = response.data?.data.provinces;
      const options25 = subCont15.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      console.log(response);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Redirect to login page if unauthorized
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
        }
        setTableData3([]);
      }
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    if (bearer && selectedContinent) {
      fetchSubContinents(selectedContinent);
    }
  }, [bearer, selectedContinent]);

  useEffect(() => {
    if (bearer && selectedRegion) {
      fetchSubRegion(selectedRegion);
    }
  }, [bearer, selectedRegion]);

  useEffect(() => {
    if (bearer) {
      fetchProvince();
    }
  }, [bearer]);
  
    // Handle process button click
    const handleProcessAccounts = async () => {
      if (!selectedProvinceFilter) {
        Swal.fire({
          title: "Selection Required",
          text: "Please select continent, region and province to process accounts.",
          icon: "info",
          confirmButtonText: "OK",
        });
        return;
      }
  
      try {
        setIsLoading(true);
        const response = await axios.get(`${BASE_URL}/provinces/get-province-accounts`, {
          params: {
            province_id: selectedProvinceFilter.value
          },
          headers
        });
  
        console.log("Province Accounts API Response:", response.data);
  
        if (response.data.status) {
          Swal.fire({
            title: "Success!",
            text: `Processing accounts for ${selectedProvinceFilter.label}`,
            icon: "success",
            confirmButtonText: "OK",
          });
          // Refresh accounts after processing
          fetchAccounts(currentPage);
        }
      } catch (error) {
        console.error("Error processing province accounts:", error);
        Swal.fire({
          title: "Error!",
          text: "Failed to process province accounts",
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        setIsLoading(false);
      }
    };
  
    const fetchContinents = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/continents`, { headers });
      const results = response.data?.data;

      const options = results.map((item) => ({
        label: item.description,
        value: item.id,
      }));
      // setCustomers(results);
      setSelectOptions(options);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (bearer) {
      fetchContinents();
    }
  }, [bearer]);


  const regionOptions = Array.isArray(regions)
    ? regions.map(region => ({
      value: region.id,
      label: region.description || 'Unnamed Region'
    }))
    : [];

  const provinceOptions = Array.isArray(provinces)
    ? provinces.map(province => ({
      value: province.id,
      label: province.description || 'Unnamed Province'
    }))
    : [];


//  const handlePrint = (rowData) => {
//   navigate("/invoice-previeww", {
//     state: {
//       invoiceNumber: rowData.invoice_number,
//       invoiceDate: rowData.invoice_date,
//       dueDate: rowData.due_date,
//       customer: {
//         name: rowData.customer_name,
//         phone_number: rowData.customer_phone,
//         email: rowData.customer_email,
//       },
//       items: rowData.items,
//       total: rowData.total,
//     },
//   });
// };


      const handleTrashClick = async (uuid) => {
        const confirmed = await Swal.fire({
          title: 'Are you sure?',
          text: 'You are about to delete this payment.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel',
        });
    
        if (!confirmed.isConfirmed) {
          return; // User canceled, do nothing
        }
    
        try {
          const response = await axios.get(`${BASE_URL}/payments/delete_perm?uuid=${uuid}`, { headers });
          Swal.fire({
            imageUrl: verified,
            title: 'Success!',
            text: response.data.message,
            confirmButtonText: "Okay",
            imageWidth: 48, 
            imageHeight: 48, 
            customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
            },
            allowOutsideClick: false,
            preConfirm: () => {
              Swal.close();
            }
          });
          fetchExpenses();
          // setTrashClicked(true);
        } catch (error) {
          let errorMessage = 'An error occurred. Please try again.';
              if (error.response && error.response.data && error.response.data.message) {
                  if (typeof error.response.data.message === 'string') {
                      errorMessage = error.response.data.message;
                  } else if (Array.isArray(error.response.data.message)) {
                      errorMessage = error.response.data.message.join('; ');
                  } else if (typeof error.response.data.message === 'object') {
                      errorMessage = JSON.stringify(error.response.data.message);
                  }
            Swal.fire({
              imageUrl: crop,
              imageWidth: 48,
              imageHeight: 48,
              title: "Failed!",
              confirmButtonText: "Okay",
              text: JSON.stringify(error.response.data.message),
              customClass: {
                title: classes.myTitle,
                popup: classes.myText,
                confirmButton: classes.myDeclineButton,
              },
              allowOutsideClick: false, // Prevent closing by clicking outside
              preConfirm: () => {
                Swal.close(); // Explicitly close the modal
              },
            });
        }
        }
      };

// const handlePrint = (id) => {
//   navigate("/print_payments", {
//     state: { invoice: tableData },
//   });
// };

const handlePrint = (uuid) => {
  const selectedInvoice = tableData.find((item) => item.uuid === uuid);
  if (selectedInvoice) {
    navigate("/print_payments", {
      state: { invoice: selectedInvoice },
    });
  }
};


  const handleCurrencyChange = (selectedOption) => {
    setSelectedCurrency(selectedOption.value);
  };

  const fetchCharts = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/beneficiary`, { headers });
      const results = response.data?.data;

      const opt1 = results.map((item) => ({
        label: item.name,
        // bank: item.bank_name,          
        value: item.id,
      }));
      console.log(response , "full reponse");
      setSuppliers(opt1);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setSuppliers([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchLoanBen = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/customer/loan-customers-select`, { headers });
      const results = response.data?.data;

      const opt1 = results.map((item) => ({
        label: item.name,
        // bank: item.bank_name,
        value: item.id,
      }));
      console.log(response , "loan Benf");
      setLoanBen(opt1);

    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setLoanBen([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (bearer) {
      fetchLoanBen();
      fetchCharts();

    }
  }, [bearer]);


  const addLine = () => {
    setRows((prev) => [
      ...prev,
      { accountId: "", accountDisplay: "", amount: "", showDropdown: false },  
    ]);
  };

  
  const fetchMode = async () => {
       
    try {
        const response = await axios.get(`${BASE_URL}/income/get-payment-method`, { headers });
        const results = response.data?.data;
        setPaymentModes(results);
    } catch (error) {
        const errorStatus = error.response?.data?.message;
        console.log(errorStatus);
      setPaymentModes([]);
    } finally {
        
    }
};

    useEffect(() => {
      if (bearer) {
        // fetchCurrency();
        fetchMode();
        // fetchDebit1();
        //       fetchDebit2();
        //   fetchTotalExpenses();
      }
    }, [bearer]);

    const fetchAccounts = async () => {
      const token = localStorage.getItem("userToken");
      // if (!token) return;
      setAccountsLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}/account/expenses`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
     
        const payload = res?.data;
        let raw = payload?.data ?? payload;
        if (raw && typeof raw === "object" && Array.isArray(raw.data)) {
          raw = raw.data;
        }
        const list = Array.isArray(raw) ? raw : [];
        setAccounts(list);
      } catch (err) {
        console.error("Error fetching accounts:", err);
        setAccounts([]);
      } finally {
        setAccountsLoading(false);
      }
    };

  useEffect(() => {
    if (showPay) {
      fetchAccounts();
    }
  }, [showPay]);

  const duplicateRow = (index) => {
    setRows((prev) => {
      const newRows = [...prev];
      const emptyRow = {
        accountId: "",
        accountDisplay: "",
        amount: "",
        showDropdown: false,
      };
      newRows.splice(index + 1, 0, emptyRow);
      return newRows;
    });
  };

  const removeRow = (index) => {
    setRows((prev) => {
      if (prev.length === 1) return prev;
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleChange = (index, field, value) => {
    setRows((prev) => {
      const newRows = [...prev];
      const row = { ...newRows[index] };

      if (field === "showDropdown") {
        row.showDropdown = value;
      } else if (field === "account") {
        row.accountId = value?.id ?? "";
        row.accountDisplay = `${value?.gl_name ?? value?.name ?? ""}`;
        row.accountCode = value?.gl_code ?? value?.code ?? "";
        row.showDropdown = false;
      } else if (field === "accountDisplay") {
        row.accountDisplay = value;
        row.accountId = "";
        row.accountCode = "";
        row.showDropdown = true;
      } else if (field === "amount") {
        row.amount = value;
      }

      newRows[index] = row;
      return newRows;
    });
  };

  

  const totalDebit = parseFloat(totalAmount || 0);
  const totalCredit = rows.reduce(
    (sum, r) => sum + (parseFloat(r.amount) || 0),
    0
  );
  const isBalanced = totalDebit === totalCredit;

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("✅ handleSubmit triggered");
    const authToken = localStorage.getItem("authToken");

    // Validate balanced amounts first
    if (!isBalanced) {
      Swal.fire({
        icon: "error",
        title: "Unbalanced Entry",
        text: "Total Debit and Total Credit must balance before saving.",
        confirmButtonColor: "#3085d6",
        customClass: { popup: "swal-highest-zindex" },
        didOpen: () => {
          const swalPopup = document.querySelector(".swal2-container");
          if (swalPopup) swalPopup.style.zIndex = "99999";
        },
      });
      return;
    }

    setIsSaving(true);

    try {
      // Build base payload
      const typeObj = paymentTypes.find(
        t => (t.name || t.type_name)?.toLowerCase().trim() === paymentTypeLower
      );

      let payload = {
        particulars: reference, // default to reference for compatibility
        description,
        currency: selectedCurrency,
        payment_mode: selectedPaymentMode,
        transaction_date: transactionDate,
        gl_code: debitAccount,
        // total_amount: totalCredit,
        account_id: rows.map((row) => row.accountId).filter(Boolean),
        breakdown_amount: rows.map((row) => parseFloat(row.amount || 0)),
        type_of_payment: typeObj?.id || "",
      };

      // adjust payload depending on payment type
      if (paymentTypeLower.includes("general")) {
        payload.particulars = reference;
      } else if (paymentTypeLower.includes("supplier")) {
        // if supplier, payment_to expected by backend
        payload.payment_to = reference;
        // remove particulars to avoid confusion if backend doesn't expect it
        delete payload.particulars;
      }

      console.log("Submitting payload:", payload);

      const response = await axios.post(
        `${BASE_URL}/v1/post-payments`,
        payload,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );

      if (response.status === 200 || response.status === 201) {
        Swal.fire({
          imageUrl: verified,
          title: "Payment Saved",
          text:
            response.data?.message ||
            "The payment has been successfully saved!",
          confirmButtonText: "Print",
          confirmButtonColor: "#16A34A",
          customClass: { popup: "swal-highest-zindex" },
          didOpen: () => {
            const swalContainer = document.querySelector(".swal2-container");
            if (swalContainer) swalContainer.style.zIndex = "99999";
          },
        }).then((result) => {
          if (result.isConfirmed) {
            const receiptData = {
              reference,
              transactionDate,
              description,
              selectedCurrency,
              selectedPaymentMode,
              debitAccount,
              // totalAmount: totalCredit,
              rows,
            };

            navigate("/preview", {
              state: { invoice: receiptData },
            });
          } else {
            // reset form values (keep structure same as your original)
            setRows([
              {
                accountId: "",
                accountDisplay: "",
                accountCode: "",
                amount: "",
                showDropdown: false,
              },
            ]);
            setReference("");
            setDescription("");
            setDebitAccount("");
            setTotalAmount("");
            setSelectedPaymentMode("");
            setTransactionDate("");
            setIsSaving(false);
            // onClose();
          }
        });
      }
    } catch (error) {
      console.error("Save error:", error);
      Swal.fire({
        imageUrl: crop,
        title: "Save Failed",
        text:
          typeof error.response?.data?.message === "object"
            ? Object.values(error.response.data.message).flat().join(", ")
            : error.response?.data?.message ||
            "An error occurred while saving the payment. Please try again.",
        confirmButtonColor: "#000000ff",
        customClass: { popup: "swal-highest-zindex" },
        didOpen: () => {
          const swalContainer = document.querySelector(".swal2-container");
          if (swalContainer) swalContainer.style.zIndex = "99999";
        },
      });
    } finally {
      setIsSaving(false);
    }
  };

  
  const fetchDebit1 = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${BASE_URL}/account/bank-accounts`,{headers});
    
      const debt1 = response.data?.data;
      const oopt1 = debt1.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,
     
        
      }));
      setDebit1(oopt1);
 

  
    } catch (error) {
      const errorStatus = error.response.data.message;
      console.error(errorStatus);
    } finally {
      setLoading(false);
    }
  };
const fetchDebit2 = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${BASE_URL}/account/cash`,{headers});
    
      const debt2 = response.data?.data;
      const oopt2 = debt2.map((item) => ({
        label: `${item.gl_code} - ${item.gl_name}`,
        value: item.id,
     
        
      }));
      setDebit2(oopt2);
 

  
    } catch (error) {
      const errorStatus = error.response.data.message;
      console.error(errorStatus);
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
if (bearer) {
// fetchCurrency();
// fetchMode();
fetchDebit1();
    fetchDebit2();
//   fetchTotalExpenses();
}
}, [bearer]);

  useEffect(() => {
    const fetchDebitAccounts = async () => {
      if (!selectedPaymentMode) return;
      const token = localStorage.getItem("authToken");
      let endpoint = "";

      const selectedModeName = paymentModes.find(m => m.id == selectedPaymentMode)?.name?.toLowerCase();

      if (selectedModeName?.includes("bank") || selectedModeName?.includes("transfer") || selectedModeName?.includes("teller")) {
        endpoint = `${BASE_URL}/bank-accounts`;
      } else if (selectedModeName?.includes("cheque") || selectedModeName?.includes("cash")) {
        endpoint = `${BASE_URL}/cash`;
      }

      if (!endpoint) return;

      setDebitAccountsLoading(true); // ✅ Start loader

      try {
        const res = await axios.get(endpoint, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        if (res.data && Array.isArray(res.data.data)) {
          const options = res.data.data.map((item) => ({
            value: item.id,
            label: item.gl_name || item.name,
          }));
          setExpenseOptions(options);
        } else {
          setExpenseOptions([]);
        }
      } catch (err) {
        console.error("Error fetching debit account options:", err);
        setExpenseOptions([]);
      } finally {
        setDebitAccountsLoading(false); // ✅ Stop loader
      }
    };

    fetchDebitAccounts();
  }, [selectedPaymentMode, paymentModes]);

  
  const debitedAccount = rows.map((row) => row.accountId || "");
const debitedAmount = rows.map((row) => row.amount || "");

  const handleFetchPayments = async () => {
    setIsSaving(true);
    try {
      // build the payload
      const payload = {
        receipt_type: Number(selectedPaymentType), // 1,2,3
        supplier_id: selectedPaymentType === "1" ? reference : '',
        customer_id: selectedPaymentType === "3" ? reference : '',
        particulars: selectedPaymentType === "2" ? reference : '',
        transaction_date: transactionDate,
        currency: selectedCurrency,  // assuming you capture currency id/code here
        payment_mode: selectedPaymentMode,
        description: description,
        credit_gl: debitAccount, // Credit account selected
        total_amount: totalAmount,
        debit_gl: debitedAccount, // account name
        breakdown_amount: debitedAmount,
        reference_no: refno,
      };
  
      console.log("Submitting payload:", payload);
  
      const response = await axios.post(`${BASE_URL}/post_payments`, payload, { headers });
  
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message,
      }).then(() => {
        window.location.reload();
      });
      
      setIsSaving(false);
      handleClosePay();
  
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
      }
  
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: errorMessage,
      });
    } 
    finally {
      setIsSaving(false); // always stop uploading, success or fail
    }
  };

  const handleEdit = async (uuid) => {
    handleShowEdit(); // Show modal immediately (you can move it after fetch if you prefer)
    setPayLoad(true); // Start loading
    setError(null); // Clear any previous error
    setSelectedPayment(null);
    try {
      // const token = localStorage.getItem("authToken");
      const res = await axios.get(`${BASE_URL}/fetch_payments_by_uuid?uuid=${uuid}`,{ headers });
      // setSelectedPayment(res.data, "fetchPayments"); // store fetched data
      const results = res.data?.data;
      const resultx = res.data?.data?.total;

      console.log(res, "full payments");
      // setTotalEntries(resultx);
      const normalizedResults = Array.isArray(results) ? results : [results];
      setSelectedPayment(normalizedResults);
      console.log(results, "ssspayments");
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setSelectedPayment([]);
    } finally {
      setPayLoad(false); // Always end loading
    }
  };
   const fetchReceipt = async () => {
    setLoads(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch-receipts-account`, {
        params: {
          // page: currentPage,
          account: selectedBank,
          start_date: selectedDate,
          end_date: selectedEndDate,
        },
        headers,
      });

      const results = response.data?.data || []; // Ensure results is an array
      // const resultx = response.data?.data?.total || 0; // Default to 0 if undefined
  
      // setTotalReceipts(resultx);
      setTableData(results);
  
      // const total = response.data?.data?.last_page || 1; // Ensure fallback to 1 if undefined
      // setTotalPages(total);
  
      console.log("Fetched Receipts:", results);
      // toast.success(response.data.message);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          }
          // Object handling for error messages
         
          console.log(errorMessage);
        }
        setTableData([]); // Clear table data in case of error
      }
    } finally {
      setLoads(false);
    }
  };
  const fetchReceipt1 = async () => {
    setLoads(true);
    try {
      const response = await axios.get(`${BASE_URL}/salary/continent`, {
        params: {
          // page: currentPage,
          // account: selectedBank,
          start_date: selectedDate,
          end_date: selectedEndDate,
          continent_id: selectedContinent || ""
        },
        headers,
      });

     const resultsss = response.data?.data;
      setTableData(resultsss);
      // toast.success(response.data.message);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          }
          // Object handling for error messages
          
          console.log(errorMessage);
        }
        setTableData([]); // Clear table data in case of error
        
      }
    } finally {
      setLoads(false);
    }
  };
   const fetchReceipt2 = async () => {
    setLoads(true);
    try {
      const response = await axios.get(`${BASE_URL}/salary/region`, {
        params: {
          // page: currentPage,
          // account: selectedBank,
          start_date: selectedDate,
          end_date: selectedEndDate,
          continent_id: selectedContinent || "",
          region_id: selectedRegion || ""
        },
        headers,
      });

    const resultsss = response.data?.data;
      setTableData(resultsss);
      // const total = response.data?.data?.last_page || 1; // Ensure fallback to 1 if undefined
      // setTotalPages(total);
  

      // toast.success(response.data.message);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          }
          // Object handling for error messages
          
          console.log(errorMessage);
        }
        setTableData([]); // Clear table data in case of error
        setTableDataQueried([]); // Clear table data in case of error
      }
    } finally {
      setLoads(false);
    }
  };

   const fetchReceipt3 = async () => {
    setLoads(true);
    try {
      const response = await axios.get(`${BASE_URL}/salary/province`, {
        params: {
          // page: currentPage,
          // account: selectedBank,
          start_date: selectedDate,
          end_date: selectedEndDate,
          continent_id: selectedContinent || "",
          region_id: selectedRegion || "",
          province_id: selectedProvince || ""
        },
        headers,
      });

      const resultsss = response.data?.data;
      setTableData(resultsss);
      // toast.success(response.data.message);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          }
          // Object handling for error messages
        //   toast.error(errorMessage);
          console.log(errorMessage);
        }
        setTableData([]); // Clear table data in case of error
      
      }
    } finally {
      setLoads(false);
    }
  };

 const handleProcess = () => {
    if (
      // !selectedBank || 
      !selectedDate || !selectedEndDate) {
      console.error("Please ensure all required fields are selected.");
      return;
    }
  handleClose()
    if (selectedContinent && selectedRegion && selectedProvince && selectedEndDate && selectedDate) {
      fetchReceipt3();
    } else if (selectedContinent && selectedRegion && selectedEndDate && selectedDate) {
      fetchReceipt2();
    } else if (selectedContinent && selectedEndDate && selectedDate) {
      // Fetch for continent only
      fetchReceipt1();
    } else {
      // Default fetch
      fetchReceipt();
    }
  };
const handleStatusChange = (e) => {
  setSelectedStatus(e.target.value);
};



  const filteredData = tableData?.filter(item => item?.name.toLowerCase().includes(searchTerm.toLowerCase()));
 

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);


  // const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const handlePrevPage = () => {
    setCurrentPage(prevPage => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages));
  };
const startIndexx = (currentPage - 1) * entriesPerPage;
const endIndexx = Math.min(startIndexx + entriesPerPage, filteredData.length);
const displayedData = filteredData.slice(startIndexx, endIndexx);

    const handleEyeClick = (id) => {
    const foundPayroll = tableData.find((item) => item.id === id);
    setSelectedRow(foundPayroll);
    console.log(foundPayroll);
    // handleShow();
       
      };

  return (
    <div>
      <HeaderNav />


      <div className={classes.Container}>
        {/* <div className={classes.actions}>
                    <button className={`${classes.btnss} ${classes.greens}`}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={classes.btns}>Product & Services </button>

                </div> */}

                <Modal show={showEdit} onHide={handleCloseEdit} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title style={{fontSize: "16px"}}>View Payment Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
  {payLoad ? (
    <p>Loading payment details...</p>
  ) : selectedPayment && selectedPayment.length > 0 ? (
    <table className={classes.table}>
      <thead>
        <tr>
          <th>Trans. Ref</th>
          <th>Beneficiary Name</th>
          <th>Description</th>
          <th>Transaction Date</th>
          <th style={{ textAlign: "right" }}>Amount Paid</th>
        </tr>
      </thead>
      <tbody>
        {selectedPayment.map((item, index) => (
          <tr key={index}>
            <td>{item.uuid}</td>
            <td style={{paddingLeft: "40px"}}>{item.particular}</td>
            <td style={{paddingLeft: "20px"}}>{item.description}</td>
            <td style={{paddingLeft: "30px"}}>
              {item.transaction_date
                ? item.transaction_date.split("T")
                : ""}
            </td>
          
            <td style={{ textAlign: "right" }}>
              {Number(item.amount).toLocaleString()}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <p>No payment data found.</p>
  )}
</Modal.Body>


        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseEdit}>
            Close
          </Button>
          {/* <Button variant="primary" onClick={() => console.log("Save changes")}>
            Save Changes
          </Button> */}
        </Modal.Footer>
      </Modal>
          


        {/* <div className={classes.actionsbtn}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div> */}

        <Modal show={showPay} onHide={handleClosePay} size="xl">
     
      <div className={classes.modalContent}>
        <h3 className={classes.title}>Payment</h3>
        <div className={classes.topRow}>
          {/* <div className={classes.Group3}>
            <label>Payment type</label>
            <select
          value={selectedPaymentType}
          onChange={(e) => {
            const value = e.target.value.toLowerCase().trim();
            setSelectedPaymentType(value);
            setReference("");
          }}
        >
          <option value="">Select Type</option>
          <option value="1">Suppliers</option>
          <option value="2">General Payment</option>
          <option value="3">Loan Disbursement</option>
        </select>
          </div> */}
          <div className={classes.Group3}>
  <label>Payment type</label>
  <select
    value={selectedPaymentType}
    onChange={(e) => {
      setSelectedPaymentType(e.target.value); // keep it as a string
      setReference("");
    }}
  >
    <option value="">Select Type</option>
    <option value="1">Supplier Payment</option>
    <option value="2">General Payment</option>
    <option value="3">Loan Disbursement</option>
  </select>
</div>

<div style={{ marginLeft: "-10px" }} className={classes.Group3}>
  <label>Payment to</label>

  {/* --- Supplier Select --- */}
  {selectedPaymentType === "1" && (
    <Select
      value={suppliers.find((opt) => opt.value === reference) || null}
      onChange={(selectedOption) =>
        setReference(selectedOption ? selectedOption.value : "")
      }
      options={suppliers}
      isLoading={isLoading}
      isDisabled={isLoading}
      placeholder="Select Supplier"
      styles={{ control: (base) => ({ ...base, width: "100%", minHeight: "35px", height: "20px", borderColor: "#ccc", boxShadow: "none", "&:hover": { borderColor: "#999" }, fontSize: "12px", }), option: (base, state) => ({ ...base, fontSize: "12px", color: state.isSelected ? "#000" : "#333", backgroundColor: state.isFocused ? "#f0f0f0" : "#fff", }), valueContainer: (base) => ({ ...base, padding: "0 4px", height: "40px", }), placeholder: (base) => ({ ...base, fontSize: "12px", color: "#999", }), singleValue: (base) => ({ ...base, fontSize: "12px", }), }}
    />
  )}

  {/* --- Loan Beneficiary Select --- */}
  {selectedPaymentType === "3" && (
    <Select
      value={loanBen.find((opt) => opt.value === reference) || null}
      onChange={(selectedOption) =>
        setReference(selectedOption ? selectedOption.value : "")
      }
      options={loanBen}
      isLoading={isLoading}
      isDisabled={isLoading}
      placeholder="Select Loan Beneficiary"
      styles={{ control: (base) => ({ ...base, width: "100%", minHeight: "35px", height: "20px", borderColor: "#ccc", boxShadow: "none", "&:hover": { borderColor: "#999" }, fontSize: "12px", }), option: (base, state) => ({ ...base, fontSize: "12px", color: state.isSelected ? "#000" : "#333", backgroundColor: state.isFocused ? "#f0f0f0" : "#fff", }), valueContainer: (base) => ({ ...base, padding: "0 4px", height: "40px", }), placeholder: (base) => ({ ...base, fontSize: "12px", color: "#999", }), singleValue: (base) => ({ ...base, fontSize: "12px", }), }}
    />
  )}

  {/* --- General Payment (Text Input) --- */}
  {selectedPaymentType === "2" && (
    <input
      type="text"
      placeholder="Enter payee name"
      style={{ width: "100%" }}
      value={reference}
      onChange={(e) => setReference(e.target.value)}
    />
  )}

  {/* --- Default State --- */}
  {!selectedPaymentType && (
    <input
      type="text"
      placeholder="Select payment type first"
      style={{ width: "100%" }}
      value=""
      disabled
    />
  )}
</div>


          <div className={classes.Group}>
            <label>Date</label>
            <input
              type="date"
              value={transactionDate}
              onChange={(e) => setTransactionDate(e.target.value)}
              required
            />
          </div>

          {/* ✅ Currency dropdown unchanged */}
          <div className={classes.Group}>
            <label>Currency</label>
            {/* <select
              value={selectedCurrency}
              onChange={(e) => setSelectedCurrency(e.target.value)}
            >
              <option value="">Select Currency</option>
              {currencyOptions.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.code || c.name}
                </option>
              ))}
            </select> */}
            <Select
  // value={selectedCurrency}
  onChange={(selectedOption) => handleCurrencyChange(selectedOption)}
  options={selectOptions}
  formatOptionLabel={(option) => (
    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
      <span style={{ fontSize: "12px" }}>{option.label}</span>
      <span style={{ fontSize: "12px", lineHeight: "1" }}>-</span>
      <span style={{ color: "#888", fontSize: "12px" }}>{option.country}</span>
    </div>
  )}
  menuPortalTarget={document.body}
  styles={{
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    control: (base) => ({
      ...base,
      minHeight: "35px",
      height: "35px",
      width: "100%",
      fontSize: "12px",
      display: "flex",
      alignItems: "center",
      flexWrap: "nowrap",           // 🔧 FIXED prevent multi-line wrap
      overflow: "hidden",           // 🔧 FIXED keep text inside container
      textOverflow: "ellipsis",     // 🔧 FIXED truncate long text gracefully
      whiteSpace: "nowrap",  
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "30px",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    })
  }}
/>

          </div>
        </div>


        <div className={classes.topRows}>
          <div className={classes.Group1}>
            <label>Description</label>
            <input
              type="text"
              placeholder="Enter description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>


          <div className={classes.Group2}>
            <label>Mode of Payment</label>
            <select 
            value={selectedPaymentMode}
            onChange={(e) => setSelectedPaymentMode(e.target.value)}
          >
            <option value="">Select Payment Mode</option>
            {paymentModes
              .filter((m) => 
                m.name?.toLowerCase().includes("bank transfer") || 
                m.name?.toLowerCase().includes("cheque")
              )
              .map((m) => (
                <option key={m.id} value={m.id}>
                  {m.name}
                </option>
              ))}
          </select>
          </div>
          <div className={classes.Group2}>
            <label>Credit Account</label>
            <Select
  value={
    debitAccount
      ? expenseOptions.find((acc) => acc.value === debitAccount)
      : null
  }
  onChange={(selectedOption) => setDebitAccount(selectedOption?.value || "")}
  options={
            selectedPaymentMode === "1" || selectedPaymentMode === "3"
              ? debit1
              : selectedPaymentMode === "2" || selectedPaymentMode === "4"
              ? debit2
              : debit1
          }
  placeholder={
    loading ? "Loading accounts..." : "Select Credit Account"
  }
  isDisabled={loading}
  isLoading={loading}
  isClearable
  styles={{
    control: (base) => ({
      ...base,
      minHeight: "32px",
      height: "32px",
      fontSize: "14px",
      borderColor: "#ccc",
      boxShadow: "none",
      "&:hover": { borderColor: "#999" },
      backgroundColor: loading ? "#f8f8f8" : "white",
      opacity: loading ? 0.7 : 1,
    }),
    valueContainer: (base) => ({
      ...base,
      height: "32px",
      padding: "0 6px",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "32px",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "13px",
      color: "#888",
    }),
    menu: (base) => ({
      ...base,
      fontSize: "14px",
    }),
  }}
/>

          </div>

        </div>
        <div className={classes.top}>
          <div className={classes.Group1}>
            <label>Total Amount</label>
            <input
              type="number"
              placeholder="Enter Amount"
              style={{ textAlign: "right" }}
              value={totalAmount}
              onChange={(e) => setTotalAmount(e.target.value)}
            />
          </div>

          <div className={classes.Group2}>
            <label>Loan Account</label>
            <select
              value={selectedLoanAccount}
              onChange={(e) => setSelectedLoanAccount(e.target.value)}
              disabled // 👈 disables it until the real API is ready
            >
              <option value="">Select Loan Account (Coming Soon)</option>
              <option value="loan-1">Loan #001 - Placeholder</option>
              <option value="loan-2">Loan #002 - Placeholder</option>
            </select>
          </div>


          <div className={classes.Group2}>
            <label>Reference/Cheque/Income/Loan No.</label>
            <input
              type="text"
              placeholder="Enter reference number"
              value={refno}
              onChange={(e) => setRefNo(e.target.value)}
            />
          </div>

          {/* ✅ Conditionally show Outstanding only for Loan Accounts */}
          {/* {(() => {
            const selectedModeName = paymentModes.find(
              (m) => m.id == selectedPaymentMode
            )?.name?.toLowerCase();

            if (selectedModeName?.includes("loan")) {
              return (
                <div className={classes.Group2}>
                  <label>Outstanding</label>
                  <input
                    type="number"
                    placeholder="0.00"
                    value={outstandingAmount || ""}
                    disabled
                  />
                </div>
              );
            }

            return null;
          })()} */}
        </div>

        <h3 className={classes.titles}>Account Breakdown</h3>
        <table className={classes.table}>
          <thead style={{backgroundColor: "#174384"}}>
            <tr >
              <th>#</th>
              <th>Account Name</th>
              <th>Account Code</th>  {/* ✅ new column */}
              <th>Amount</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>


                <td className={classes.accountCell}>
                  <div className={classes.searchableDropdown}>
                    <input
                      type="text"
                      value={row.accountDisplay}
                      onChange={(e) => handleChange(index, "accountDisplay", e.target.value)}
                      onFocus={() => handleChange(index, "showDropdown", true)}
                      onClick={() =>
                        handleChange(index, "showDropdown", !row.showDropdown)
                      }
                      placeholder="Search or type account..."
                      className={classes.accountInput}
                    />

                    {row.showDropdown && (
                      <div
                        className={classes.dropdownList}
                        onMouseLeave={() => handleChange(index, "showDropdown", false)} // ✅ close when mouse leaves dropdown
                      >
                        {accountsLoading ? (
                          <div className={classes.dropdownLoading}>
                            <Spinner animation="border" size="sm" />
                          </div>
                        ) : (
                          accounts
                            .filter((acc) => {
                              const search = row.accountDisplay?.toLowerCase() || "";
                              const text = `${acc.gl_code ?? acc.code ?? ""} ${acc.gl_name ?? acc.name ?? ""
                                }`.toLowerCase();
                              return text.includes(search);
                            })
                            .slice(0, 10)
                            .map((acc) => (
                              <div
                                key={acc.id}
                                className={classes.dropdownItem}
                                onClick={() => handleChange(index, "account", acc)}
                              >
                                {`${acc.gl_code ?? acc.code ?? ""} - ${acc.gl_name ?? acc.name ?? ""
                                  }`}
                              </div>
                            ))
                        )}
                      </div>
                    )}
                  </div>
                </td>


                {/* ✅ Account Code column */}
                <td>
                  <input
                    type="text"
                    value={row.accountCode}
                    readOnly
                    className={classes.readOnlyInput}
                    disabled
                  />
                </td>


                <td>
                  <input
                    type="number"
                    className={classes.creditInput}
                    value={row.amount}
                    onChange={(e) =>
                      handleChange(index, "amount", e.target.value)
                    }
                  />
                </td>

                <td>
                  {/* <button
                    onClick={() => duplicateRow(index)}
                    className={classes.linkBtn}
                    disabled={paymentTypeLower.includes("supplier")}
                    style={{
                      opacity: paymentTypeLower.includes("supplier") ? 0.6 : 1,
                      cursor: paymentTypeLower.includes("supplier") ? "not-allowed" : "pointer",
                    }}
                  >
                    Duplicate
                  </button> */}
                  <button
                    onClick={() => removeRow(index)}
                    className={classes.removeBtn}
                    style={{marginLeft: "40px"}}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className={classes.actionRow}>
          <button className={classes.addLineBtn} onClick={addLine}>
            + Add Line
          </button>
        </div>

        <div className={classes.totalRow}>
          <div className={classes.totalBox}>
            <span style={{whiteSpace: "nowrap"}} >Total Debit</span>
            <strong style={{whiteSpace: "normal", wordBreak: "break-word" }}>{totalDebit.toFixed(2)}</strong>
          </div>
          <div className={classes.totalBox}>
            <span style={{whiteSpace: "nowrap"}}>Total Credit</span>
            <strong style={{whiteSpace: "normal", wordBreak: "break-word" }}>{totalCredit.toFixed(2)}</strong>
          </div>
        </div>

        {/* <form  */}
        {/* // onSubmit={handleSubmit}
        > */}
          <div className={classes.footerButtons}>
            <button
              type="button"
              className={classes.resetBtn}
              onClick={() =>
                setRows([
                  {
                    accountId: "",
                    accountDisplay: "",
                    amount: "",
                    showDropdown: false,
                  },
                ])
              }
            >
              Reset
            </button>

            {/* <button type="button" className={classes.printBtn} onClick={handlePrinter}>
              Print
            </button> */}

            <button
              type="submit"
              className={classes.submitBtn}
              // disabled={isSaving || !isBalanced}
              onClick={handleFetchPayments}
            >
              {isSaving ? (
                <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                  <Spinner animation="border" size="sm" /> Saving...
                </span>
              ) : (
                "Save Payments"
              )}
            </button>
          </div>
        {/* </form> */}

        <button className={classes.closeBtn} onClick={handleClosePay}>
          ×
        </button>
      </div>

      {/* <Modal.Footer>
        <Button variant="secondary" onClick={handleClosePay}>Reset</Button>
        <Button style={{ backgroundColor: '#092147', borderColor: '#092147' }} onClick={() => console.log({ paymentType, paymentTo, date, currency, description, modeOfPayment, debitAccount, totalAmount, loanAccount, reference, lines })}>Save Receipt</Button>
      </Modal.Footer> */}
    </Modal>

        <header className={classes.Header}>
          <h2 className={classes.Title}>Payroll</h2>
          <h1 className={classes.Titles}>
        View Payroll by selecting the below required field
          </h1>
        </header>
          <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
          
            <div className={classes.filterSection}>
          <div className={classes.filterContainer}>
            <div className={classes.filterItem}>
              <label className={classes.filterLabel}>Continent</label>
             <Select
                           onChange={(selectedOption) => handleContinentChange(selectedOption)}
                             options={selectOptions}
                             placeholder="Select Continent"
                            
  menuPortalTarget={document.body}
styles={{
    control: (base) => ({
      ...base,
      minHeight: "32px",
      height: "32px",
      fontSize: "12px",
      borderColor: "#ccc",
      boxShadow: "none",
      "&:hover": { borderColor: "#999" },
      width: "100%", // ensures it respects parent width
    }),
    valueContainer: (base) => ({
      ...base,
      height: "32px",
      padding: "0 6px",
      overflow: "hidden",
    }),
    singleValue: (base) => ({
      ...base,
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      maxWidth: "100%",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "32px",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "13px",
      color: "#888",
    }),
    menu: (base) => ({
      ...base,
      fontSize: "12px",
      width: "100%", // keeps dropdown aligned with control
    }),
  }}
   className={classes.filterSelect}
/>

            </div>

            <div className={classes.filterItem}>
              <label className={classes.filterLabel}>Region</label>
              <Select
               
                onChange={handleRegionChange}
                options={tableData3}
                placeholder="Select Region"
                className={classes.filterSelect}
                 styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "32px",
                  height: "32px",
                  fontSize: "12px",
                  borderColor: "#ccc",
                  boxShadow: "none",
                  "&:hover": { borderColor: "#999" },
                }),
                valueContainer: (base) => ({
                  ...base,
                  height: "32px",
                  padding: "0 6px",
                }),
                input: (base) => ({
                  ...base,
                  margin: 0,
                  padding: 0,
                }),
                indicatorsContainer: (base) => ({
                  ...base,
                  height: "32px",
                }),
                placeholder: (base) => ({
                  ...base,
                  fontSize: "13px",
                  color: "#888",
                }),
                menu: (base) => ({
                  ...base,
                  fontSize: "12px",
                }),
              }}
              />
            </div>

            <div className={classes.filterItem}>
              <label className={classes.filterLabel}>Province</label>
              <Select
                onChange={(selectedOption) => handleProvinceChange(selectedOption)}
                                      options={tableData4}
                placeholder="Select Province"
                className={classes.filterSelect}
                 styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "32px",
                  height: "32px",
                  fontSize: "12px",
                  borderColor: "#ccc",
                  boxShadow: "none",
                  "&:hover": { borderColor: "#999" },
                }),
                valueContainer: (base) => ({
                  ...base,
                  height: "32px",
                  padding: "0 6px",
                }),
                input: (base) => ({
                  ...base,
                  margin: 0,
                  padding: 0,
                }),
                indicatorsContainer: (base) => ({
                  ...base,
                  height: "32px",
                }),
                placeholder: (base) => ({
                  ...base,
                  fontSize: "13px",
                  color: "#888",
                }),
                menu: (base) => ({
                  ...base,
                  fontSize: "12px",
                }),
              }}
              />
            </div>
       <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="date-filter-tooltip">Select a date range</Tooltip>}
      >
        <Button
          variant="primary"
          onClick={handleShow}
          size="sm"
          className={classes.btnsss}
          title="Select Date Range"
         
        >
          Filter By Date
        </Button>
      </OverlayTrigger>
       {loads ? (
                                    <>
                                      <Spinner size='sm' />
                                     
                                    </>
                                  ) : (
                                    null
                                  )}
              {/* <div className={classes.filterItem}>
  <label className={classes.filterLabel}>Start Date</label>
  <input
    type="date"
   onChange={handleDateChange} name="start"
    value={selectedDate}
    className={classes.filterSelect}
  />
</div>
<div className={classes.filterItem}>
  <label className={classes.filterLabel}>End Date</label>
  <input
    type="date"
   onChange={handleDateChange1} name="start" value={selectedEndDate}
    className={classes.filterSelect}
  />
</div> */}
<Modal
        show={show}
        onHide={handleClose}
        size="sm"
        aria-labelledby="date-filter-modal"
        dialogClassName={classes.customModal} // Custom class for modal width
      >
        <Modal.Header closeButton>
          <Modal.Title id="date-filter-modal" style={{ fontSize: '0.9rem' }}>
            Date Range
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.dateContainer}>
          <div className={classes.filterItem} style={{ marginBottom: 10 }}>
            <label
              htmlFor="start-date"
              className={classes.filterLabel}
              style={{ fontSize: '0.75rem' }}
            >
              Start
            </label>
            <input
              id="start-date"
              type="date"
              onChange={handleDateChange}
              name="start"
              value={selectedDate}
              className={classes.filterSelect}
              style={{ fontSize: '0.8rem' }}
            />
          </div>
          <div className={classes.filterItem} style={{ marginBottom: 10 }}>
            <label
              htmlFor="end-date"
              className={classes.filterLabel}
              style={{ fontSize: '0.75rem' }}
            >
              End
            </label>
            <input
              id="end-date"
              type="date"
              onChange={handleDateChange1}
              name="end"
              value={selectedEndDate}
              className={classes.filterSelect}
              style={{ fontSize: '0.8rem' }}
            />
          </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            className={classes.btnss}
            onClick={handleProcess}
            size="sm"
          >
           {loads ? (
                                    <>
                                      <Spinner size='sm' />
                                     
                                    </>
                                  ) : (
                                    "Apply"
                                  )}
          </Button>
        </Modal.Footer>
      </Modal>
          </div>
          <div className={classes.filterContainer1}>
          



             {/* <div className={classes.filterItem}>
              <label className={classes.filterLabel}>&nbsp;</label>
              <Button
                className={classes.manageButton}
                onClick={handleProcess}
              >
                {loads ? (
                                    <>
                                      <Spinner size='sm' />
                                     
                                    </>
                                  ) : (
                                    "Process"
                                  )}
              </Button>
            </div> */}
          </div>
        </div>
          </div>
          <div className={classes.actionsLeft}>
              <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search Receipt" value={searchTerm} onChange={(e) => {
                                              setSearchTerm(e.target.value);
                                              // setCurrentPage(1);
                                            }}/>
            </div>
        
          </div>
        </div>

      

        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <table className={classes.invoiceTable}>
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr style={{ fontSize: "12px" }}>
                  <th style={{width: "5%"}}>S/N</th>
                  <th style={{width: "5%"}}>Staff ID</th>
                  <th style={{width: "15%"}}>Staff Name</th>
                  <th style={{width: "10%"}}>Month</th>
                  <th style={{width: "7%"}}>Monthly Basic</th>
                  <th style={{width: "7%"}}>Gross Pay</th>
                  <th style={{width: "10%"}}>Net Pay</th>
                  <th style={{width: "7%"}}>Action</th>
                </tr>
              </thead>
              <tbody>

                {isLoading
                  ? Array(5)
                    .fill()
                    .map((_, idx) => (
                      <tr key={idx}>
                        {Array(8)
                          .fill()
                          .map((_, i) => (
                            <td key={i}>
                              <Skeleton height={20} style={{ marginBottom: 10 }} />
                            </td>
                          ))}
                      </tr>
                    ))
                  : displayedData.length === 0 ? (
                    <tr>
                      <td colSpan={10} style={{ textAlign: "center" }}>
                        No payment found.
                      </td>
                    </tr>
                  ) : (
                    displayedData.map((item, index) => (
                      <tr key={item.id} style={{ fontSize: "12px" }}>
                        <td>{index + 1}</td>
                        <td>{item.staff_id}</td>
                        <td>{item.name}</td>
                        <td>{item.month}</td>
                    <td style={{textAlign: "right"}}> {parseFloat(item.basic_salary).toLocaleString('en-US', {
                                                  minimumIntegerDigits: 1,
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2
                                                })}
                                            </td>
                       <td style={{textAlign: "right"}}> {parseFloat(item.gross).toLocaleString('en-US', {
                                                  minimumIntegerDigits: 1,
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2
                                                })}
                                            </td>
                                            <td style={{textAlign: "right"}}> {parseFloat(item.net_pay).toLocaleString('en-US', {
                                                  minimumIntegerDigits: 1,
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2
                                                })}
                                            </td>
                         
                             <td style={{ textAlign: "center" }}>
                                                  <FaCalendarCheck onClick={() => handleEyeClick(item.id)} style={{ height: 22, color: "#2d995f", cursor: 'pointer', }} />
                                                <FaCalendarXmark style={{ height: 22, color: "#dc3545", cursor: 'pointer', marginLeft: 10 }} />
                                             
                                       
                          
                          {/* <Eye size={16} className={classes.editIcon} onClick={() => handlePrint(item)}
                            style={{ cursor: "pointer" }} /> */}
                        </td>
                      </tr>
                    ))
                  )}
              </tbody>
            </table>


          </table>

          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button                   
                onClick={handlePrevPage}
                disabled={currentPage === 1}
              >Previous</button>
              {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return(
                <button className={classes.active}  key={page + 1}
                style={{
                  color: page + 1 === currentPage ? '#ffffff' : '#000',
                  backgroundColor: page + 1 === currentPage ? '#174384' : 'gainsboro',
                  cursor: "pointer"
                }}
                onClick={() => setCurrentPage(page + 1)}
              > {page + 1}
              </button>
                    );
                  }
                  return null;
                })}
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >Next
              </button>
              <span className={classes.pageText}>Displaying {startIndexx} - {endIndexx} of {totalEntries}</span>
            </div>
          </div>


        </div>
      </div>
      <Modal show={show1} onHide={handleClose1} animation={false} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>New Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form style={{ paddingLeft: "25px", paddingRight: "25px" }}>
              <Row style={{ marginBottom: "10px"}}>
                <Col md={6}>
                  <Form.Check
                    label="Supplier/Contractor"
                    name="group1"
                    type="radio"
                    id="supplier"
                    value="supplier"
                    checked={selectedRadio === "supplier"}
                    onChange={handleRadioChange}
                    className={classes.radioGreen}
                  />
                </Col>
                <Col md={6}>
                  <Form.Check
                    label="General Payment"
                    name="group1"
                    type="radio"
                    id="general"
                    value="general"
                    checked={selectedRadio === "general"}
                    onChange={handleRadioChange}
                    className={classes.radioGreen}
                  />
                </Col>
              </Row>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Row style={{ marginBottom: "15px" }}>
                 {selectedRadio === "supplier" && (
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Payment to:</label>
                      </Col>
                      <Col md={9}>
                          <Select
                            options={customerOptions}
                            value={selectedCustomer}
                            onChange={setSelectedCustomer}
                            placeholder="Select Supplier"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                      </Col>
                    </Row>
                  </Col>
                 )}
                 {selectedRadio === "general" && (
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Payment to:</label>
                      </Col>
                      <Col md={9}>
                          <Form.Control
                            type="text"
                            value={customerName}
                            onChange={(e) => {
                              const value = e.target.value;
                              const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                              setCustomerName(filteredValue);
                            }}
                            required
                            style={{ width: "100%" }}
                          />
                      </Col>
                    </Row>
                  </Col>
                 )}
                  <Col md={12} style={{ marginBottom: 10 }}>
                        <Row>
                          <Col md={3} style={{ textAlign: "right" }}>
                              <label style={{ width: "100%" }}>Date:</label>
                          </Col>
                          <Col md={9}>
                            <Form.Control
                              type="date"
                              value={paymentDate}
                              onChange={e => setPaymentDate(e.target.value)}
                              required
                              style={{ width: "100%" }}
                            />
                          </Col>
                        </Row>
                  </Col>
                  <Col md={12} style={{ marginBottom: 10 }}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label style={{ width: "100%" }}>Description:</label>
                    </Col>
                      <Col md={9}>
                        <Form.Control
                          as="textarea"
                          value={description}
                          rows={1}
                          onChange={(e) => {
                            const value = e.target.value;
                            const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                            setDescription(filteredValue);
                          }}
                          required
                          style={{ width: "100%" }}
                        />
                      </Col>
                  </Row>
                  </Col>
                  <Col md={12}>
                      <Row>
                        <Col md={3} style={{ textAlign: "right" }}>
                          <label>Mode:</label>
                        </Col>
                        <Col md={9}>
                          <Select
                            options={paymentMode}
                            value={selectedPaymentMode}
                            onChange={setSelectedPaymentMode}
                            placeholder="Select Payment Mode"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                        </Col>
                      </Row>
                  </Col>
              </Row>
              <Row>
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Currency:</label>
                      </Col>
                      <Col md={9}>
                        <Row>
                          <Col md={5}>
                            <Select
                              options={currencyOptions}
                              value={selectedCurrency}
                              onChange={setSelectedCurrency}
                              placeholder="Currency"
                              isClearable
                              classNamePrefix="react-select"
                              required
                            />
                          </Col>
                          <Col md={7}>
                            <Row>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <label style={{ width: "100%" }}>Amount:</label>
                              </Col>
                              <Col md={8}>
                              <CurrencyInput
                                id="total-amount"
                                name="totalAmount"
                                value={amount}
                                decimalsLimit={2}
                                onValueChange={(value) => setAmount(value)}
                                prefix="₦"
                                groupSeparator=","
                                placeholder="Amount"
                                className={`form-control ${classes.optioncss}`}
                              />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Credit:</label>
                      </Col>
                      <Col md={9}>
                        <Row>
                          <Col md={5}>
                            <Select
                              options={bankOptions}
                              value={selectedBank}
                              onChange={setSelectedBank}
                              placeholder="Account"
                              isClearable
                              classNamePrefix="react-select"
                              required
                            />
                          </Col>
                          <Col md={7}>
                            <Row>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <label style={{ width: "100%" }}>Debit:</label>
                              </Col>
                              <Col md={8}>
                                <Select
                                  options={bankOptions2}
                                  value={selectedBank2}
                                  onChange={setSelectedBank2}
                                  placeholder="Account"
                                  isClearable
                                  classNamePrefix="react-select"
                                  required
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
              </Row>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ paddingLeft: "25px", paddingRight: "25px" }}>
          <Button variant="light" onClick={handleClose1}>
            Go back
          </Button>
          <Button variant="success" onClick={addPayment} disabled={addpaymenntLoad} className={classes.btnss}>
              {addpaymenntLoad ? (
                <>
                  <Spinner size="sm" />
                  <span style={{ marginLeft: "5px" }}>
                    Processing, Please wait...
                  </span>
                </>
              ) : (
                "Save Payment"
              )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={show2} onHide={handleClose2} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>New Supplier's Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Row style={{ marginBottom: "15px" }}>
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Payment to:</label>
                      </Col>
                      <Col md={9}>
                          <Select
                            options={invoiceOptions}
                            value={selectedInvoice}
                            onChange={(option) => {
                              setSelectedInvoice(option);
                              setAmount(option?.balance || "");
                            }}
                            // onChange={setSelectedInvoice}
                            placeholder="Select Supplier"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                          <label style={{ width: "100%" }}>Date:</label>
                      </Col>
                      <Col md={9}>
                        <Form.Control
                          type="date"
                          value={paymentDate}
                          onChange={e => setPaymentDate(e.target.value)}
                          required
                          style={{ width: "100%" }}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12} style={{ marginBottom: 10 }}>
                  <Row>
                    <Col md={3} style={{ textAlign: "right" }}>
                      <label style={{ width: "100%" }}>Description:</label>
                    </Col>
                      <Col md={9}>
                        <Form.Control
                          as="textarea"
                          value={description}
                          rows={1}
                          onChange={(e) => {
                            const value = e.target.value;
                            const filteredValue = value.replace(/[^a-zA-Z0-9.@,\- ]/g, '');
                            setDescription(filteredValue);
                          }}
                          required
                          style={{ width: "100%" }}
                        />
                      </Col>
                  </Row>
                  </Col>
                  <Col md={12}>
                      <Row>
                        <Col md={3} style={{ textAlign: "right" }}>
                          <label>Mode:</label>
                        </Col>
                        <Col md={9}>
                          <Select
                            options={paymentMode}
                            value={selectedPaymentMode}
                            onChange={setSelectedPaymentMode}
                            placeholder="Select Payment Mode"
                            isClearable
                            classNamePrefix="react-select"
                            required
                          />
                        </Col>
                      </Row>
                  </Col>
              </Row>
              <Row>
                  <Col md={12} style={{ marginBottom: 10 }}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Currency:</label>
                      </Col>
                      <Col md={9}>
                        <Row>
                          <Col md={5}>
                            <Select
                              options={currencyOptions}
                              value={selectedCurrency}
                              onChange={setSelectedCurrency}
                              placeholder="Currency"
                              isClearable
                              classNamePrefix="react-select"
                              required
                            />
                          </Col>
                          <Col md={7}>
                            <Row>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <label style={{ width: "100%" }}>Amount:</label>
                              </Col>
                              <Col md={8}>
                              <CurrencyInput
                                id="total-amount"
                                name="totalAmount"
                                value={amount}
                                decimalsLimit={2}
                                onValueChange={(value) => setAmount(value)}
                                prefix="₦"
                                groupSeparator=","
                                placeholder="Amount"
                                className={`form-control ${classes.optioncss}`}
                                readOnly
                              />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={12}>
                    <Row>
                      <Col md={3} style={{ textAlign: "right" }}>
                        <label>Credit:</label>
                      </Col>
                      <Col md={9}>
                        <Row>
                          <Col md={5}>
                            <Select
                              options={bankOptions}
                              value={selectedBank}
                              onChange={setSelectedBank}
                              placeholder="Account"
                              isClearable
                              classNamePrefix="react-select"
                              required
                            />
                          </Col>
                          <Col md={7}>
                            <Row>
                              <Col md={4} style={{ textAlign: "right" }}>
                                <label style={{ width: "100%" }}>Debit:</label>
                              </Col>
                              <Col md={8}>
                                <Select
                                  options={bankOptions2}
                                  value={selectedBank2}
                                  onChange={setSelectedBank2}
                                  placeholder="Account"
                                  isClearable
                                  classNamePrefix="react-select"
                                  required
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
              </Row>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={handleClose2}>
            Go back
          </Button>
          <Button variant="success" onClick={addPayment2} disabled={addpaymenntLoad2} className={classes.btnss}>
              {addpaymenntLoad2 ? (
                <>
                  <Spinner size="sm" />
                  <span style={{ marginLeft: "5px" }}>
                    Processing, Please wait...
                  </span>
                </>
              ) : (
                "Save Payment"
              )}
          </Button>
        </Modal.Footer>
      </Modal>
        <PaymentsUploadModal
            isOpen={openJournalModal}
            onClose={() => setOpenJournalModal(false)}
        />

      {/* <Footer /> */}
    </div>
  );
};

export default Payroll;
